import { MDBBtn, MDBContainer, MDBFile } from 'mdb-react-ui-kit';
import React, { useContext, useState } from 'react';
import { ResumeContext } from "../../context/resume/resume-context";
import { getUserWithResumesById, http } from '../services/httpService';

function FileUploadForm({ onUploadData, userId, resumeId }) {
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const { dispatch } = useContext(ResumeContext);

    const token = localStorage.getItem("token")

    const uploadFile = async (file, extractionType) => {
        setLoading(true);

        const formData = new FormData();
        formData.append('file', file);
        formData.append('userId', userId);
        formData.append('cvId', resumeId); // TODO adapt the backend to receive any id, create an old Cv, call python, then convert back the old Cv into a new one

        try {
            const response = await http('api/v1/extractor', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: formData,
            });

            if (response.ok) {
                const data = await response.json();
                onUploadData(extractionType, data);
            } 
        } catch (error) {
            console.error(`Exception to upload fichier for ${extractionType}:`, error);
        } finally {
            setLoading(false);
        }
    };

    const fetchCvData = async () => {
        try {
            const response = await getUserWithResumesById(userId);
 
            if (!response.ok) {
                throw new Error(`Network response was not ok, status: ${response.status}`);
            }
 
            const data = await response.json();
            const resumeData = data.resumes.find( resume => resume.id === Number.parseInt(resumeId));
 
            dispatch({
                type: 'SET_RESUME_DATA',
                payload: resumeData || {},
            });
 
        } catch (error) {
            console.error(`Error fetching CV data: ${error}`);
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (selectedFile) {
            // The backend already returns the structured resume; avoid refetching which would overwrite the filled data.
            await uploadFile(selectedFile, "STRUCTURED");
        }
    };

    const handleFileChange = event => {
        setSelectedFile(event.target.files[0]);
    };

    return (
        <MDBContainer className=''>
            <div className=''>
                <form onSubmit={handleSubmit} className='d-flex justify-content-center gap-1'>
                    <div>
                        <MDBFile onChange={handleFileChange} />
                    </div>
                    <div>
                        <MDBBtn className='mb-2 btn btn-secondary text-light' type="submit" style={{ backgroundColor: "#09B4BF" }}>
                            Extraire des données
                        </MDBBtn>
                    </div>
                </form>
                {loading && ( // Affichage conditionnel du spinner
                    <div className="text-center mt-3">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )}
            </div>
        </MDBContainer>
    );
}

export default FileUploadForm;
